import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { getObjectShape, isObject } from './lib/walk-schema.js';
import { readMeta } from './lib/read-meta.js';
import { ZodField } from './zod-field.js';
/**
 * Recursively render every property of a ZodObject schema as a <ZodField>,
 * honouring meta.order and meta.group for sorting.
 */
export function RenderSchema({ schema, prefix = '', skip = [], }) {
    if (!isObject(schema)) {
        return _jsx(_Fragment, {});
    }
    const shape = getObjectShape(schema);
    const entries = Object.entries(shape)
        .filter(([k]) => !skip.includes(k))
        .map(([k, child]) => ({ key: k, child, meta: readMeta(child) }))
        .sort((a, b) => {
        const ao = a.meta.order ?? 0;
        const bo = b.meta.order ?? 0;
        return ao - bo;
    });
    return (_jsx(_Fragment, { children: entries.map(({ key, child }) => {
            const name = prefix ? `${prefix}.${key}` : key;
            return _jsx(ZodField, { name: name, schema: child }, name);
        }) }));
}
//# sourceMappingURL=render-schema.js.map